export const PAGE_SIZE = 20;
export const MESSAGE_DURATION = 5000;
export const GENDER_ARR = [{label:'男', value :'1'} ,{label: '女', value : '0'}]
export const regMobilePone = /^1[3456789]\d{9}$/;
export const regEmail = /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
export const usrNameReg = /^[a-zA-Z0-9]{4,16}$/;
export const passWordReg = /^[a-zA-Z0-9%$@!]{6,16}$/;
export const regInteger = /^[1-9]\d*$/;
export const roleType = {
    usr: "usr",
    deptAdmin: "dept_admin",
    admin: "admin",
}

export const fileType = {
    NOTICE_FILE:"通知公告",
    USER_HEAD_IMG:"用户头像",
    EXAM_IMG:"考试题目",
    SAFE_KNOWLEDGE:"安全知识",
    REGULATIONS: {
        NAME: "规章制度" ,
        SUB_TYPE: {
          COUNTRY :"国家规定",      
          LOCAL : "地方文件", 
          OTHER : "其余文件"
        }
    }, // 国家 地方 其余
    WORK_GUID:"办事指南",
    SAFE_BOOK :"安全责任书"
}
export const  fileAreaType = {

    CONTENT:"内容区",
    ATTACH:"附件区"
}
export const  ConstAnswerCheckType = {

    RADIO:'单选题',
    CHECKBOX:'多选题',
    // INDEFINITE:'不定项选择题',
    TRUE_OR_FALSE:'判断题'
}

export const ConstAnswerCheckTypeList = [ConstAnswerCheckType.RADIO,
    ConstAnswerCheckType.CHECKBOX, 
    ConstAnswerCheckType.TRUE_OR_FALSE ]
export const themeConfigState ={
    CONFIG_QUESTION_TYPE:1,
    CONFIG_TITLE:2,
    CONFIG_PEOPLE:3
}



// WEBPACK FOOTER //
// ./src/api/constant.js